<template>
  <section
    class="relative w-full overflow-hidden bg-cover bg-center bg-no-repeat after:absolute after:left-0 after:top-0 after:block after:h-full after:w-full after:bg-gradient-to-r after:from-blue-700/50 after:to-adv_blue-700/50 after:content-['']"
    :style="bannerStyle"
  >
    <div
      class="container-wrap relative z-10 flex min-h-mobile-banner py-12 tablet:h-[360px]"
    >
      <div class="flex w-full flex-col items-center justify-center">
        <div class="mx-auto w-full max-w-[760px] text-center">
          <h2 class="text-h2 banner-title mb-2 text-white">
            {{ contextData.title }}
          </h2>
          <p class="mb-4 text-sm text-white tablet:mb-6 tablet:text-base">
            {{ contextData.description }}
          </p>
          <div class="w-full tablet:flex tablet:justify-center tablet:gap-6">
            <div
              v-if="contextItems[0]"
              class="mb-4 rounded-lg border border-solid border-white bg-white/20 px-4 py-4 text-center backdrop-blur-md tablet:mb-0 tablet:w-6/12 desktop:px-8 desktop:py-6"
            >
              <p class="mb-2 text-white tablet:mb-4 tablet:text-lg">
                {{ contextItems[0].name }}
              </p>
              <TheButton
                :id="contextItems[0].button.trackingCode"
                :to="provideFormatUrl(contextItems[0].button.link)"
                :title="contextItems[0].button.text"
                type="outline"
                class="w-full"
                @click="
                  contextItems[0].button.hadnleClick &&
                  contextItems[0].button.hadnleClick()
                "
              >
                <span class="text-sm">{{ contextItems[0].button.text }}</span>
              </TheButton>
            </div>
            <div
              v-if="contextItems[1]"
              class="rounded-lg border border-solid border-white bg-white/20 px-4 py-4 text-center backdrop-blur-md tablet:w-6/12 desktop:px-8 desktop:py-6"
            >
              <p class="mb-2 text-white tablet:mb-4 tablet:text-lg">
                {{ contextItems[1].name }}
              </p>
              <TheButton
                :id="contextItems[1].button.trackingCode"
                :to="provideFormatUrl(contextItems[1].button.link)"
                :title="contextItems[1].button.text"
                class="w-full"
                @click="
                  contextItems[1].button.hadnleClick &&
                  contextItems[1].button.hadnleClick()
                "
              >
                <span class="text-sm">{{ contextItems[1].button.text }}</span>
              </TheButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
  import type { ISuiteProps } from '@/components/Shared/Suite/type.ts';

  interface IButton {
    text: string;
    link: string;
    trackingCode?: string;
    hadnleClick?: () => void;
  }

  interface IItem {
    name: string;
    button: IButton;
  }

  interface IStartedBannerData {
    title: string;
    description: string;
    thumbnail: string;
    items: IItem[];
  }

  interface IStartedBanner {
    component: 'topics-started-banner';
    meta: {
      navigable?: string;
    };
    data: IStartedBannerData;
  }

  type IProps = ISuiteProps<IStartedBanner>;

  const props = defineProps<IProps>();

  const { provideFormatUrl } = useFormatUrl();

  const contextData = computed((): IStartedBannerData => props.suiteData.data);

  const contextItems = computed((): IItem[] => contextData.value.items);

  const bannerStyle = computed((): string => {
    return `background-image: url(${contextData.value.thumbnail})`;
  });

  export type { IItem, IStartedBanner, IStartedBannerData };
</script>
